import AbstractModel from './AbstractModel'
import Mapper from './mapper/Mapper'
import Column from './table/Column'
import SelectColumn from './table/SelectColumn'
import DateColumn from './table/DateColumn'

class Attrezzature extends AbstractModel {
  permission () {
    return {
      'USR': {
        action: { isInsertable: true, isEditable: true, isDeletable: true },
        columns: {
          dexattr: { onEditDisabled: true }
        }
      },
      'ADM': {
        action: { isImpersonate: true, isInsertable: true, isEditable: true, isDeletable: true },
        columns: {}
      }
    }
  }
  mapper () {
    return [
      Mapper.column.azienda(true),
      Mapper.column.ambito()
    ]
  }
  columns () {
    return [
      new Column('btn').withHtml(true).withWidth('100px').withIsEditable(false).withIsInsertable(false).withExportable(false),
      new Column('id').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new Column('idazi').withType('number').withIsEditable(false).withIsInsertable(false).withIsVisible(false),
      new SelectColumn('ambito', Mapper.select.ambito()).withType('text').withIsVisible(false).withOnEditDisabled(true).withOnInsertDisabled(true),
      new Column('dexattr').withType('text'),
      new Column('marcamodello').withType('text'),
      new Column('ambiente').withType('text'),
      new Column('dichconf').withHtmlType('switch').withType('boolean'),
      new Column('libretto').withHtmlType('switch').withType('boolean'),
      new DateColumn('dataacq'),
      new DateColumn('datadis'),
      new Column('targatelaio').withType('text').withIsVisible(false),
      new SelectColumn('idcoll', Mapper.select.dipendente('aziende')).withType('number'),
      new DateColumn('datamanu').withIsVisible(false),
      new DateColumn('datarevi').withIsVisible(false),
      new Column('omologa').withType('text').withIsVisible(false),
      new Column('note').withType('text').withIsVisible(false)
    ]
  }

  validator () {
    return {
      idazi: { required: true, type: 'number' },
      ambito: { required: true, type: 'string' }
    }
  }
}

export default new Attrezzature()
